import React, {
  Component
} from 'react';
import {
  Link
} from 'react-router-dom';
import {
  Container,
  Header,
  Icon,
  Menu,
  Segment
} from 'semantic-ui-react';
import {
  Route
} from 'react-router-dom';
import AdminRichTextSection from './AdminRichTextSection';
import AdminPublicTramitesView from './AdminPublicTramitesView';

class AdminPublicPagesView extends Component {

  constructor (props) {
    super(props);

    this.state = {

    };
  }

  render () {
    return (
      <Container style={{ padding: 16 }}>
        <Header as="h2">
          <Icon name="users" />
          <Header.Content>
            Secciones Publicas
            <Header.Subheader>
              Administrar Secciones Publicas
            </Header.Subheader>
          </Header.Content>
        </Header>
        <Menu attached="top" tabular>
          <Menu.Item
            as={Link} to="/public/portada"
            active={!!window.location.pathname.match(new RegExp(`^/public/portada/?$`))}
            name="portada" />
          <Menu.Item
            as={Link} to="/public/tramites"
            active={!!window.location.pathname.match(new RegExp(`^/public/tramites/.*`))}
            name="guia de tramites" />
        </Menu>
        <Route path={`${this.props.match.url}/portada`} render={() => {
          return (
            <Segment attached="bottom">
              <AdminRichTextSection sectionName="portada" />
            </Segment>
          );
        }} />
        <Route path={`${this.props.match.url}/tramites/`} render={() => {
          return (
            <Segment attached="bottom">
              <AdminPublicTramitesView />
            </Segment>
          );
        }} />
      </Container>
    );
  }

}

export default AdminPublicPagesView;


// WEBPACK FOOTER //
// ./client/components/pages/public-pages/AdminPublicPagesView.js